import * as PIXI from "./core/PIXI";

const fragment = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec3 uColor;
void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * vec4(uColor, 1.);
}
`;

export default class ColorOverlayFilter extends PIXI.Filter
{
    
    constructor(red: number, green: number, blue: number)
    {
        super(null, fragment);

        this.uniforms.uColor = [];
        this.setColor(red, green, blue);
    }

    setColor(red: number, green: number, blue: number)
    {
        this.uniforms.uColor[0] = red;
        this.uniforms.uColor[1] = green;
        this.uniforms.uColor[2] = blue;
    }

    get color()
    {
        return this.uniforms.uColor;
    }

}